const permission = {
  namespaced: true,
  
  state: {
    routes: [],
    addRoutes: [],
    sidebarRouters: []
  },

  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = routes
    },
    SET_SIDEBAR_ROUTERS: (state, routes) => {
      state.sidebarRouters = routes
    }
  },

  actions: {
    // 生成路由（根据已有权限过滤）
    GenerateRoutes({ commit, rootState }) {
      return new Promise((resolve) => {
        const permissions = rootState.permissions || []
        
        commit('SET_ROUTES', [])
        commit('SET_SIDEBAR_ROUTERS', [])

        resolve([])
      })
    }
  }
}

export default permission
